/**
 * 需要在全局入口文件中引入的hmap环境
 * @author wjx 2018年10月8日 19:22:24
 */

// import { detectOS, createScript } from './util'
import {createScript} from './util'

const env = process.env.NODE_ENV // 环境
// const platform = detectOS() // 平台

// 引入cordova
if(env === 'production' || env === 'uat') {
  // // 在线子应用
  // if (platform === 'ios') {
  //   createScript('static/cordova/ios/cordova.js')
  // } else if (platform === 'android') {
  //   createScript('static/cordova/android/cordova.js')
  // }

  // 本地子应用
  createScript('../../cordova.js')
}



// WEBPACK FOOTER //
// ./src/platform/hmap/env.js